/**
 * by 型 COURSE cap 下,从"资格集"里挑出真正计入的那批课(供 Pool 详情页 Completed 区展示)。
 *
 * 为什么不能"每类挑一门":逐类独立贪心会挑少。实测某用户
 *   PHS-AS 只有 EAS1101 一门;GLC-AS 有 EAS1101、GOVT1313 两门。
 * 按声明序 GLC 先拿走 EAS1101 → PHS 无课可挑 → 列 7 门,而标题写 8/8。
 * 正解:让 GLC 改用 GOVT1313、EAS1101 留给 PHS —— 即允许"把已占位的课挪走"(Kuhn 增广路)。
 *
 * 最大匹配的大小唯一,故挑出的门数恒等于 appliedUnitsCount(哪怕挑中的具体课与后端不同);
 * 排序固定 → 同一份数据每次挑同一组课,不会在"计入/不计入"间跳动。
 *
 * 与后端 pool-evaluator.ts 的 matchByCap/tryAssign 同源,已对着引擎验过门数一致。
 */

function tryAssign(
    groupsOf: string[][],
    occupants: Map<string, number[]>,
    capN: number,
    i: number,
    visited: Set<string>,
): boolean {
    for (const g of groupsOf[i]) {
        if (visited.has(g)) continue;
        visited.add(g);
        const occ = occupants.get(g) ?? [];
        if (occ.length < capN) {
            occ.push(i);
            occupants.set(g, occ);
            return true;
        }
        for (let k = 0; k < occ.length; k++) {
            if (tryAssign(groupsOf, occupants, capN, occ[k], visited)) {
                occ[k] = i;
                return true;
            }
        }
    }
    return false;
}

export function pickCountedCourses(args: {
    /** cap.memberGroupValues:courseId → 该课落在本 cap 白名单内的分组值 */
    memberGroupValues: Record<string, string[]>;
    /** constraint.eligibleCourseIds:过完本 constraint where 的 COMPLETED 成员 */
    eligibleCourseIds: string[];
    /** cap.n:**每组**上限(非总上限) */
    capN: number;
}): string[] {
    const { memberGroupValues, eligibleCourseIds, capN } = args;
    // 排序固定 → 挑中谁稳定(顺序不影响门数,只影响挑中谁)
    const pool = eligibleCourseIds.filter((id) => memberGroupValues[id] !== undefined).sort();
    // 未命中 cap 的课(无任何分布码)不受封顶、全额计入,不进匹配
    const uncapped = pool.filter((id) => memberGroupValues[id].length === 0);
    const capped = pool.filter((id) => memberGroupValues[id].length > 0);

    const groupsOf = capped.map((id) => memberGroupValues[id]);
    const occupants = new Map<string, number[]>();
    for (let i = 0; i < groupsOf.length; i++) tryAssign(groupsOf, occupants, capN, i, new Set());

    const matched: string[] = [];
    occupants.forEach((occ) => occ.forEach((i) => matched.push(capped[i])));
    return [...uncapped, ...matched].sort();
}
